export const betaSuggestionModalEvents = {
    SHOW_BETA_SUGGESTION: 'betaSuggestionModal/show',
    HIDE_BETA_SUGGESTION: 'betaSuggestionModal/hide',
};
const showBetaSuggestionModal = () => {
    const event = new CustomEvent(betaSuggestionModalEvents.SHOW_BETA_SUGGESTION);
    window.dispatchEvent(event);
};
const hideBetaSuggestionModal = () => {
    const event = new CustomEvent(betaSuggestionModalEvents.HIDE_BETA_SUGGESTION);
    window.dispatchEvent(event);
};
export default {
    showBetaSuggestionModal,
    hideBetaSuggestionModal,
};